import { render, staticRenderFns } from "./activate-office-pbs-modal.vue?vue&type=template&id=060a1b2b&"
import script from "./activate-office-pbs-modal.vue?vue&type=script&lang=js&"
export * from "./activate-office-pbs-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports